import {
  BadgeCheck,
  Bell,
  CircleUserRound,
  FileUser,
  FolderKanban,
  LayoutDashboard,
  Medal,
  Sparkles,
} from "lucide-react";

export const applicantNavigationSections = [
  {
    key: "applicant_os",
    label: "Applicant OS",
    items: [
      {
        href: "/dashboard/applicant",
        label: "Vorbereitung",
        icon: LayoutDashboard,
        match: (location) => location.pathname === "/dashboard/applicant",
      },
      {
        href: "/dashboard/applicant/edit-profile",
        label: "Profil",
        icon: CircleUserRound,
        match: (location) => location.pathname === "/dashboard/applicant/edit-profile",
      },
    ],
  },
  {
    key: "workspaces",
    label: "Arbeitsbereiche",
    items: [
      {
        href: "/dashboard/applicant/bewerbung",
        label: "Bewerbung",
        icon: FileUser,
        match: (location) => location.pathname === "/dashboard/applicant/bewerbung" || location.pathname === "/dashboard/applicant/cv2",
      },
      {
        href: "/dashboard/applicant/sprachtest-b1",
        label: "Sprachtest B1",
        icon: BadgeCheck,
        match: (location) => location.pathname === "/dashboard/applicant/sprachtest-b1",
      },
      {
        href: "/dashboard/applicant/filing-requests",
        label: "Unterlagen",
        icon: FolderKanban,
        match: (location) => location.pathname === "/dashboard/applicant/filing-requests",
      },
      {
        href: "/dashboard/applicant/matches",
        label: "Chancen",
        icon: Sparkles,
        match: (location) => location.pathname === "/dashboard/applicant/matches",
      },
      {
        href: "/dashboard/applicant/nachrichten",
        label: "Nachrichten",
        icon: Bell,
        match: (location) => location.pathname === "/dashboard/applicant/nachrichten",
      },
    ],
  },
  {
    key: "progress",
    label: "Verlauf",
    items: [
      {
        href: "/dashboard/applicant/erfolge",
        label: "Erfolge",
        icon: Medal,
        match: (location) => location.pathname === "/dashboard/applicant/erfolge",
      },
    ],
  },
];

export function flattenApplicantNavigationSections(sections = applicantNavigationSections) {
  return (sections || []).flatMap((section) => section.items || []);
}

export const applicantNavigationItems = flattenApplicantNavigationSections(applicantNavigationSections);
